import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { Subscription } from 'src/features/subscriptions/utils/types';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/cancel-plan-change/';

type MutationFnType = typeof mutationFn;

interface DTO {
    subscriptionId: string;
}

/** `400 no_scheduled_plan_change` when nothing is pending. */
const mutationFn = ({ subscriptionId }: DTO): Promise<Subscription> => {
    return axios.post(formatResourcePath(RESOURCE, { subscriptionId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCancelSubscriptionPlanChange };
